import { ScreenSize } from 'lib/constants';
import { getScreenSize } from 'lib/riskbase';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Dimensions, ScaledSize } from 'react-native';

export const useScreenSize = (alternative?: boolean): ScreenSize => {
  const getTypeFromShortestLength = useCallback(
    (width: number, height: number): ScreenSize => {
      if (alternative) {
        return width < 550 ? ScreenSize.small : ScreenSize.large;
      }
      return getScreenSize({ width, height }).size;
    },
    [alternative],
  );

  const initType = useMemo(
    () =>
      getTypeFromShortestLength(
        Dimensions.get('window').width,
        Dimensions.get('window').height,
      ),
    [getTypeFromShortestLength],
  );

  const [type, setType] = useState<ScreenSize>(initType);

  const onChange = useCallback(
    ({ window }: { window: ScaledSize }) => {
      setType(getTypeFromShortestLength(window.width, window.height));
    },
    [getTypeFromShortestLength],
  );

  useEffect(() => {
    const listener = Dimensions.addEventListener('change', onChange);
    return () => {
      listener.remove();
    };
  }, [onChange]);

  return type;
};

// type Breakpoint = {
//   key: string;
//   size: number;
// };

// export const useScreenSizeBreakpoints = (
//   breakpoints?: Breakpoint[],
// ): ScreenSize => {
//   const getTypeFromShortestLength = useCallback(
//     (width: number, height: number): ScreenSize => {
//       if (alternative) {
//         return width < 550 ? ScreenSize.small : ScreenSize.large;
//       }
//       return getScreenSize({ width, height }).size;
//     },
//     [alternative],
//   );

//   const [type, setType] = useState<ScreenSize>(
//     getTypeFromShortestLength(
//       Dimensions.get('window').width,
//       Dimensions.get('window').height,
//     ),
//   );

//   const onChange = useCallback(
//     ({ window }: { window: ScaledSize }) => {
//       setType(getTypeFromShortestLength(window.width, window.height));
//     },
//     [getTypeFromShortestLength],
//   );

//   useEffect(() => {
//     const listener = Dimensions.addEventListener('change', onChange);
//     return () => {
//       listener.remove();
//     };
//   }, [onChange]);

//   return type;
// };
